import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";

export const AuthLayout = () => {
  return (
    <>
      <div className="authLayout">
        <Outlet />
        <Footer />
      </div>
    </>
  );
};
